module.exports = __webpack_public_path__ + "static/media/logo.0a6c200c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand/logo.svg
// module id = 233
// module chunks = 0